import reduce from 'lodash/reduce';
import sortBy from 'lodash/sortBy';
import mapValues from 'lodash/mapValues';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';

const getSortedProps = (props) => {
  const list = reduce(props, (result, item, key) => [...result, [key, item]], []);

  const sortedList = sortBy(list, ['0']);

  return reduce(sortedList, (result, item) => ({
    ...result,
    [item[0]]: item[1],
  }), {});
};

const getDeeplySortedProps = (props) => {
  const sorted = getSortedProps(props);

  return mapValues(sorted, (item) => {
    if (!isPlainObject(item)) {
      return item;
    }

    return getDeeplySortedProps(item);
  });
};

const getResourceKey = (name, mainKey, parentIdentity) =>
  `${name}-${ mainKey }${parentIdentity ? `-(${parentIdentity.key})` : ''}`;

const resourceId = (name, props, parentIdentity) => {
  if (name == 'load' && props.id) {
    props.id = props.id.split('/')[0];
  }
  const mainKey = JSON.stringify(getDeeplySortedProps(props));

  return {
    name,
    props,
    parentIdentity,
    shortkey: mainKey,
    mediumkey: `${mainKey }-${name}-${parentIdentity ? parentIdentity.name : ''}`,
    key: getResourceKey(name, mainKey, parentIdentity),
  };
};

export const getResource = (fullState, identity) =>
  get(fullState, ['resources', 'byName', identity.name, identity.key]);

export const getResourceWithoutId = (fullState, name, props, parentIdentity) => {
  const identity = resourceId(name, props, parentIdentity);

  return getResource(fullState, identity);
};

export default resourceId;



// WEBPACK FOOTER //
// ./src/misc/resourceId.js